// DialogOptions.js
import styles from './DialogScreen.module.css'; 
import { playUserAudio, toggleTranslation } from '../../utils/dialogUtils';

export const DialogOptions = ({ options, matchedOptionIndex, showTranslation, dispatch, combinedIsAndroidApp, site }) => (
  <div className={styles.dialogContent}>
    {(options || []).map((option, index) => (
      <div key={index} className={styles.dialogOption} onClick={() => toggleTranslation(dispatch, `option-${index}`)}>
        <div className={styles.optionContent}>
          {option.userAudioUrl && (
            <button onClick={(e) => { 
				e.stopPropagation(); 
				const audioSrc = `${combinedIsAndroidApp ? site : ''}${option.userAudioUrl}`;
				playUserAudio(audioSrc, dispatch); 
			}} 
			className={styles.audioButton}>
              <svg viewBox="0 0 24 24" className={styles.audioIconUser}>
                <path d="M3 10v4h4l5 5V5L7 10H3zm13.5 2c0-1.77-1.02-3.29-2.5-4.03v8.06A4.984 4.984 0 0 0 16.5 12zm2.5 0c0 3.04-1.64 5.64-4.06 7.03l1.43 1.43A9.969 9.969 0 0 0 22 12c0-3.73-2.05-6.99-5.13-8.64l-1.43 1.43A7.97 7.97 0 0 1 19 12z"/>
              </svg>
            </button>
          )}
          <div className={styles.textContent}>
            <p>{option.userText || 'Нет текста'}</p>
            {showTranslation[`option-${index}`] && <p className={styles.translation}>{option.userTextTranslate || ''}</p>}
          </div>
          {matchedOptionIndex === index && <span className={styles.checkmark}>✔</span>}
        </div>
      </div>
    ))}
  </div>
);